import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { FC, MouseEvent, useRef } from 'react';

import { useBoolean } from 'hooks';

import PreviewImage from '../PreviewImage';
import { ThumbnailImageStyled } from './ThumbnailImage.styled';

export const ThumbnailImage: FC<{ src: string }> = ({ src }) => {
    const [editor] = useLexicalComposerContext();
    const isEditable = useRef(editor.isEditable());
    const { value: isEnlarged, setFalse, setTrue } = useBoolean(false);

    const handleThumbnailImageClick = (event: MouseEvent<HTMLImageElement>) => {
        event.stopPropagation();
        isEditable.current = editor.isEditable();
        editor.blur();
        editor.setEditable(false);
        setTrue();
    };

    const handlePreviewImageClose = () => {
        if (isEditable.current) {
            editor.setEditable(true);
            editor.focus(() => null, { defaultSelection: 'rootEnd' });
        }
        setFalse();
    };

    return (
        <>
            <ThumbnailImageStyled src={src} onClick={handleThumbnailImageClick} />
            {isEnlarged && <PreviewImage src={src} onClose={handlePreviewImageClose} />}
        </>
    );
};

ThumbnailImage.displayName = 'ThumbnailImage';
